import React from 'react';

import { createFastFilterDateLabel } from '@vlabs/monokit/shared/lib/fast-filter-date-label';
import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';

// eslint-disable-next-line import-x/no-namespace
import * as fastFilters from './fast-filters';
import { useListFacesPageFilters } from '../../../useListDetailsFilters';

function ListFacesFastFilters(): React.JSX.Element {
  const { filters, updateFilters } = useListFacesPageFilters();

  return (
    <FastFilterGroup>
      {Object.entries(filters).map(([name, value]) => {
        if (value === undefined) return undefined;
        switch (name) {
          case 'face_ids': return (
            <fastFilters.FaceIdsFilterWithBottomPopover
              data-testid={name}
              key={name}
              onClear={() => updateFilters({ face_ids: undefined })}
              value={value}
            />
          );
          case 'user_data': return (
            <fastFilters.UserDataFilterWithBottomPopover
              data-testid={name}
              key={name}
              onClear={() => updateFilters({ user_data: undefined })}
              value={value}
            />
          );
          default: return undefined;
        }
      })}
      {!!(filters.create_time__gte ?? filters.create_time__lt) && (
        <fastFilters.DateFilterWithBottomPopover
          data-testid="create_time"
          key="create_time"
          onClear={() => updateFilters({ create_time__gte: undefined, create_time__lt: undefined })}
          value={createFastFilterDateLabel({
            createTimeGte: filters.create_time__gte,
            createTimeLt: filters.create_time__lt,
          })}
        />
      )}
    </FastFilterGroup>
  );
}

export { ListFacesFastFilters };
